import { LngLatLike } from "mapbox-gl";
import { MapViewState } from "../types/mapbox.types";

export const MAPBOX_TOKEN: string = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || "";
export const MAPBOX_STYLE: string = process.env.REACT_APP_MAPBOX_STYLE || "";
export const MODEL_GEOJSON_URL: string = process.env.REACT_APP_MODEL_GEOJSON_URL || "";
export const WARD_GEOJSON_URL: string = process.env.REACT_APP_WARD_GEOJSON_URL || "";

export const GEOJSON_URLS: string[] = [
    `https://coppumbracodevstorage.blob.core.windows.net/3dmaps/Albert Park Model Layer.geojson`,
    `https://coppumbracodevstorage.blob.core.windows.net/3dmaps/Elwood Model Layer.geojson`,
    `https://coppumbracodevstorage.blob.core.windows.net/3dmaps/Port Melbourne Industry Model Layer.geojson`,
    `https://coppumbracodevstorage.blob.core.windows.net/3dmaps/Port Melbourne Model Layer.geojson`,
    `https://coppumbracodevstorage.blob.core.windows.net/3dmaps/South Melbourne Model Layer.geojson`,
    `https://coppumbracodevstorage.blob.core.windows.net/3dmaps/St Kilda - Central Model Layer.geojson`,
    `https://coppumbracodevstorage.blob.core.windows.net/3dmaps/St Kilda - East Model Layer.geojson`,
    `https://coppumbracodevstorage.blob.core.windows.net/3dmaps/St Kilda - West Model Layer.geojson`,
  ];

export const DEFAULT_VIEW: MapViewState = {
    latitude: -37.86155175787079,
    longitude: 144.97159524645164,
    zoom: 12.5,
    bearing: 0,
    pitch: 40,
    antialias: true,
    centre: [144.97159524645164, -37.86155175787079],
};

export const BOUNDS: [LngLatLike, LngLatLike] = [
    [144.91033993341807, -37.89729001675099], // Southwest coordinates
    [145.0134423283179, -37.8156692328041], // Northeast coordinates
];
